import Layout from '@/components/feature/Layout';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ArticleCard from '@/components/base/ArticleCard';
import { articles } from '@/mocks/article';

export default function Articles() {
  return (
    <Layout>
      <div className="pt-24 pb-14">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <Breadcrumb items={[{ label: '动漫资讯' }]} />
          <h1 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-2">动漫资讯</h1>
          <p className="text-sm text-foreground-500 mb-8">最新动漫资讯、深度解读与追番指南</p>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {articles.map((article) => (
              <ArticleCard key={article.id} article={article} />
            ))}
          </div>
        </div>
      </div>
    </Layout>
  );
}